import React, {createContext, useContext, useState} from 'react';

const RunAuditOnlineStatusContext = createContext({
  online: null,
  setOnline: val => val,
  auditOnline: null,
  setAuditOnline: val => val,
  synchronizing: null,
  setSynchronizing: val => val,
  runAuditReload: null,
  setRunAuditReload: val => val
});

const useRunAuditOnlineStatus = () => {
  const context = useContext(RunAuditOnlineStatusContext);
  if (context === undefined) {
    throw new Error('useRunAuditOnlineStatus must be used within a RunAuditOnlineStatusContext');
  }
  return context;
};

const RunAuditOnlineStatusProvider = ({ ...props }) => {
  const [online, setOnline] = useState(true);
  const [auditOnline, setAuditOnline] = useState(true);
  const [synchronizing, setSynchronizing] = useState(false);
  const [runAuditReload, setRunAuditReload] = useState(false);

  return (
    <RunAuditOnlineStatusContext.Provider
      value={{
        online,
        setOnline,
        auditOnline,
        setAuditOnline,
        synchronizing,
        setSynchronizing,
        runAuditReload,
        setRunAuditReload
      }}
      {...props}
    />
  );
};

export { useRunAuditOnlineStatus, RunAuditOnlineStatusProvider };

